import { render, staticRenderFns } from "./StatuteSelect.vue?vue&type=template&id=335c2f36&scoped=true&lang=pug"
import script from "./StatuteSelect.vue?vue&type=script&lang=js"
export * from "./StatuteSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335c2f36",
  null
  
)

export default component.exports